export default __webpack_public_path__ + "static/media/trending-down.11473363.svg";